import axios from '../../utils/axios';
import CRUD from './crud'

const tournaments = new CRUD('tournaments', 'superior-judge')

export default Object.assign(
    tournaments,
    {
        reducers: {
            ...tournaments.reducers
        },

        checkSchedules: (id) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournaments/${id}/check-schedules`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        musicZIP: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/${id}/archives/music`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        resultsDocument: (id, group) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/${id}/generate-results`, {group}, { responseType: 'blob' })
                } catch (error) {
                    console.error(error);
                }
            };
        },

        awardingsZIP: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/${id}/archives/awardings`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        participantPaymentsZIP: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/${id}/archives/participant-payments`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        bookingPaymentsZIP: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/${id}/archives/booking-payments`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        ticketsPaymentsZIP: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/${id}/archives/tickets-payments`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        documentsZIP: (id, key) => {
            return async (dispatch) => {
                dispatch(tournaments.slice.actions.startLoading());
                try {
                    return axios.get(`/superior-judge/tournaments/${id}/documents/${key}/zip`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        documentsView: (id, key) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournaments/${id}/documents/${key}/view`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        googleReportParticipants: (id) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournaments/${id}/google-report-participants`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        statsParticipants: (id) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournaments/${id}/stats-participants`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        statsBookings: (id) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournaments/${id}/stats-bookings`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        invite: (id, message) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/${id}/invite`, {
                        message
                    })
                } catch (error) {
                    console.error(error);
                }
            };
        },

        reorderNumbers: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/${id}/reorder-numbers`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        progress: (id, limit = null) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournaments/${id}/progress?limit=${limit}`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        statsBySchool: (id) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournaments/${id}/stats-by-school`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        copy: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/${id}/copy`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        saveDisabledParticipantDiscounts: (id, items) => {
            return async (dispatch) => {
                const response = await axios.put(`/superior-judge/tournaments/${id}/disabled-participant-discounts`, { items });
                return response.data;
            };
        },

        saveNotifications: (settings) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/settings/notifications`, settings)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        saveInvoices: (settings) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/settings/invoices`, settings)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        saveTickets: (settings) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/settings/tickets`, settings)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        saveParticipants: (settings) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/${settings.id}/definitions/participants`, settings)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        saveBooking: (settings) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/${settings.id}/definitions/booking`, settings)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        saveRanks: (settings) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/${settings.id}/definitions/ranks`, settings)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        saveVotes: (settings) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/${settings.id}/definitions/votes`, settings)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        saveMusic: (settings) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/${settings.id}/definitions/music`, settings)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        saveDocuments: (settings) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournaments/${settings.id}/definitions/documents`, settings)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        future: () => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournaments/future`)
                } catch (error) {
                    console.error(error);
                }
            };
        },


    }
)
